/* eslint-disable */
import * as types from './action_types';
import Immutable from 'immutable';

export const initialState = Immutable.fromJS({
  pathname: undefined,
  lastPathname: undefined,
  afterTackPathname: undefined,
  lastScrollPosition: 0,
  afterTackScrollPosition: 0
});

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.PATH_SET:
      return state.merge({ pathname: action.pathname, lastPathname: state.get('pathname'), lastScrollPosition: action.lastScrollPosition });
    case types.AFTER_TACK_PATH_SET:
      return state.merge({ afterTackPathname: action.afterTackPathname, afterTackScrollPosition: state.get('lastScrollPosition') });
      case types.AFTER_TACK_PATH_RESET:
        return state.merge({ afterTackPathname: undefined, afterTackScrollPosition: 0 });      
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/stores/navigation/reducer.js